{#if isEditMode}
    <EditOwnerInformation 
        bind:this={edit}
        owner={owner}
        terms={terms}
        urls={urls.editOwnerUrls}
        canEditEmail={canEditEmail}
        nameMaxLength={nameMaxLength}
        summaryMaxLength={summaryMaxLength}
        antiForgeryHeaderSettings={antiForgeryHeaderSettings}
        fileRepoSettings={fileRepoSettings}
        fileValidationSettings={fileValidationSettings}
        on:savePortfolioOwner={onSavePortfolioOwner}
        on:cancelEditPortfolioOwner={onCancelEditPortfolioOwner} />
{:else}
    <ViewOwnerInformation 
        bind:this={view}
        owner={owner}
        terms={terms}
        canEdit={true}
        publicAccessUrl={urls.publicAccess}
        on:editPortfolioOwner={onEditPortfolioOwner} 
        on:showShareDialog={showShareDialog} />
{/if}

<script>
    import { createEventDispatcher, tick } from 'svelte';

    import ViewOwnerInformation from './ViewOwnerInformation.svelte';
    import EditOwnerInformation from './EditOwnerInformation.svelte';

    import { copyOwner } from '../common';

    export let owner = {};
    export let urls = {};
    export let canEditEmail = {};
    export let terms = {};
    export let antiForgeryHeaderSettings = {};
    export let fileRepoSettings = {};
    export let fileValidationSettings = {};
    export let isEditMode = false;
    export let nameMaxLength = 0;
    export let summaryMaxLength = 0;

    const dispatch = createEventDispatcher();

    /** @type EditOwnerInformation */
    let edit;
    /** @type ViewOwnerInformation */
    let view;

    function onSavePortfolioOwner(event) {
        owner = copyOwner(event.detail.owner);
        toggleEditMode(false);
    }

    function onCancelEditPortfolioOwner() {
        toggleEditMode(false);
    }

    function onEditPortfolioOwner() {
        toggleEditMode(true);
    }

    async function toggleEditMode(isEditModeValue) {
        isEditMode = isEditModeValue;
        await tick();

        if (isEditMode) {
            edit.setFocusOnUploadAvatarButton();
        } else {
            view.setFocusOnEditButton();
        }
    }

    function showShareDialog() {
        dispatch('showShareDialog', {});
    }
</script>
